import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from './api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(username, password);
      if (res.success && res.token) {
        localStorage.setItem('token', res.token);
        nav('/');
      } else {
        setError(res.message || 'خطا 1');
      }
    } catch (err) {
      setError(err.message || 'خطا 2');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{display:'flex', minHeight:'100vh', alignItems:'center', justifyContent:'center'}}>
      <div className="card" style={{width:420}}>
        <h2 style={{textAlign:'right'}}>پنل مدیریت گارانتی</h2>
        <form onSubmit={onSubmit}>
          <div style={{marginBottom:12}}>
            <label style={{display:'block', textAlign:'right'}}>نام کاربری</label>
            <input value={username} onChange={e=>setUsername(e.target.value)} style={{width:'100%', padding:8}}/>
          </div>
          <div style={{marginBottom:12}}>
            <label style={{display:'block', textAlign:'right'}}>پسورد</label>
            <input value={password} onChange={e=>setPassword(e.target.value)} type="password" style={{width:'100%', padding:8}}/>
          </div>
          {error && <div style={{color:'red', marginBottom:8, textAlign:'right'}}>{error}</div>}
          <div style={{display:'flex', justifyContent:'flex-start', gap:8}}>
            <button className="btn primary" disabled={loading} type="submit">{loading ? 'درحال بررسی' : 'ورود'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
